 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"cbd0934610c9e522e6238dbad52717792c1183dd","3":"8c536f4c35eae21156130cc5aab8767893b9fe6a","4":"f6fe59b5abb90426718db904dcc699ace840aadc","5":"9d5af8ce4fd93de68ca991da43017241e7752859","6":"1f12ce0e5fa036fedb12f2b83cb98d2f5e1d9280","7":"9415823cbbd8d592bf8e7435ded73122978965fa","8":"c79c6c6336477bf6cfefd935b581514a795d5207","9":"framework","12":"component---src-pages-404-js","13":"component---src-templates-archive-collaboration-js","14":"component---src-templates-archive-crops-js","15":"component---src-templates-archive-members-js","16":"component---src-templates-archive-news-js","17":"component---src-templates-archive-people-js","18":"component---src-templates-archive-topics-js","19":"component---src-templates-archive-vbs-js","20":"component---src-templates-archive-videos-js","21":"component---src-templates-collaboration-js","22":"component---src-templates-contact-us-js","23":"component---src-templates-crops-js","24":"component---src-templates-database-main-page-js","25":"component---src-templates-database-page-js","26":"component---src-templates-ethics-js","27":"component---src-templates-euroseeds-js","28":"component---src-templates-frontpage-js","29":"component---src-templates-media-kit-js","30":"component---src-templates-news-js","31":"component---src-templates-organisation-page-js","32":"component---src-templates-page-js","33":"component---src-templates-people-js","34":"component---src-templates-post-js","35":"component---src-templates-resources-js","36":"component---src-templates-search-js","37":"component---src-templates-subjects-js","38":"component---src-templates-topics-js","39":"component---src-templates-vbs-js"}[chunkId]||chunkId) + "-" + {"0":"a3774e398f121b04857a","1":"e9d24b1846c7d6eb9685","2":"e3d2900115efb5c9671b","3":"7bde0e6406e54c275bca","4":"bd492247895d7fde486c","5":"66ae44221b195c613db6","6":"fe7ba44cac0920eb4eb2","7":"59cd55ae6c99ecf673ed","8":"95013dc8928d13517db0","9":"9b0124523c3fd41f0d84","12":"b099fe85ee2cab4bb86a","13":"076832abd6220ee6706f","14":"5b85d5e324676838a5e7","15":"b1b0c10243f8daf7c523","16":"cce752d7b01baf086de6","17":"c41835ecd5ce8929670c","18":"5dd9f791fde4f4e311b2","19":"62c2373d9b5f1d8ca0a4","20":"8a341a7c7f2ad71380d2","21":"2a06b336a1351520a141","22":"1d78db536ba69a019e87","23":"61868ad373a2469ba573","24":"bf4d4ae4c3f143df7585","25":"4fb3e8ff297230f767e6","26":"bd60f71e12ecd1df36da","27":"a425b153442906be7307","28":"1680f9dccfd38f10f4f5","29":"e970004281d44c7f9ce8","30":"2e9bc470b8ecec844ce3","31":"328f2a09ccbe7f69eedf","32":"4dbd7ec079a46c7e74c2","33":"4ee4d5d457206910dc9b","34":"7d54f0947956d74f9d19","35":"c58a590bcead6810ffa1","36":"48cf2bf7402fc732d82e","37":"4d5fdb5ba7cef344641d","38":"b08b8cece335a39ce6d9","39":"1ecbc76163416d45dc5b","41":"263ce0210e41dfc06994"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"cbd0934610c9e522e6238dbad52717792c1183dd","3":"8c536f4c35eae21156130cc5aab8767893b9fe6a","4":"f6fe59b5abb90426718db904dcc699ace840aadc","5":"9d5af8ce4fd93de68ca991da43017241e7752859","6":"1f12ce0e5fa036fedb12f2b83cb98d2f5e1d9280","7":"9415823cbbd8d592bf8e7435ded73122978965fa","8":"c79c6c6336477bf6cfefd935b581514a795d5207","9":"framework","12":"component---src-pages-404-js","13":"component---src-templates-archive-collaboration-js","14":"component---src-templates-archive-crops-js","15":"component---src-templates-archive-members-js","16":"component---src-templates-archive-news-js","17":"component---src-templates-archive-people-js","18":"component---src-templates-archive-topics-js","19":"component---src-templates-archive-vbs-js","20":"component---src-templates-archive-videos-js","21":"component---src-templates-collaboration-js","22":"component---src-templates-contact-us-js","23":"component---src-templates-crops-js","24":"component---src-templates-database-main-page-js","25":"component---src-templates-database-page-js","26":"component---src-templates-ethics-js","27":"component---src-templates-euroseeds-js","28":"component---src-templates-frontpage-js","29":"component---src-templates-media-kit-js","30":"component---src-templates-news-js","31":"component---src-templates-organisation-page-js","32":"component---src-templates-page-js","33":"component---src-templates-people-js","34":"component---src-templates-post-js","35":"component---src-templates-resources-js","36":"component---src-templates-search-js","37":"component---src-templates-subjects-js","38":"component---src-templates-topics-js","39":"component---src-templates-vbs-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"b7b4538ec4c1500cc2be","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
